/* eslint-disable no-debugger */
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from 'axios';

const initialState = {
  isLoading: false,
  isSaveLoading: false,
  error: '',
  status: true,
  createColumnStatus: false,
  columnNames: [],
  smartHeaders: [],
  columnMapId: null,
  CopyFromColumnList: []
};

const slice = createSlice({
  name: 'columnmap',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    startSaveLoad(state) {
      state.isSaveLoading = true;
    },
    // RESET ERROR
    resetColumnError(state) {
      state.error = '';
    },
    // RESET CREATE STATUS
    resetCreateColumnStatus(state) {
      state.createColumnStatus = false;
    },
    // HAS ERROR
    hasError(state, action) {
      const { message } = action.payload?.data;
      state.createColumnStatus = false;
      state.isLoading = false;
      state.isSaveLoading = false;
      state.error = message;
    },
    // GET COLUMNS NAMES
    getExtractedColumnsSuccess(state, action) {
      const { Keys, id, headers } = action.payload;
      state.columnNames = Keys;
      state.smartHeaders = headers;
      state.columnMapId = id;
      state.isLoading = false;
    },
    // GET COLUMN MAP LIST DONE
    getCopyFromColumnListSuccess(state, action) {
      state.CopyFromColumnList = action.payload;
      state.isLoading = false;
    },
    // CREATE COLUMN
    createColumnmapSuccess(state, action) {
      const newColumnMapList = action.payload;
      state.createColumnStatus = true;
      state.columnNames = [];
      state.smartHeaders = [];
      state.columnMapId = null;
      state.isSaveLoading = false;
      state.CopyFromColumnList = [...state.CopyFromColumnList, newColumnMapList];
    },
    copyExternalColumnsSuccess(state, action) {
      state.columnNames = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { resetColumnError, resetCreateColumnStatus } = slice.actions;

// ----------------------------------------------------------------------

// GET COLUMN MAP LIST DONE GET
export function getColumnMapList() {
  return async (dispatch) => {
    // dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'get',
        url: `http://smartcollect-api.cp360apps.com/columnmapping/`
      });
      dispatch(slice.actions.getCopyFromColumnListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// GET COLUMN NAMES FROM EXCEL POST
export function getColumnNames(file) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'post',
        url: `http://smartcollect-api.cp360apps.com/columnmapping/get-keys/excel/`,
        data: file
      });
      dispatch(slice.actions.getExtractedColumnsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

// CREATE COLUMN MAP POST
export function createColumnmap(columnData, id) {
  return async (dispatch) => {
    dispatch(slice.actions.startSaveLoad());
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const response = await axios({
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        method: 'post',
        url: `http://smartcollect-api.cp360apps.com/columnmapping/create/${id}/`,
        data: columnData
      });
      dispatch(slice.actions.createColumnmapSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.response));
    }
  };
}

export function getCopyExternalColumns(columnData) {
  return async (dispatch) => {
    const columns = columnData?.map((a) => a?.key);
    dispatch(slice.actions.copyExternalColumnsSuccess(columns));
  };
}

// ----------------------------------------------------------------------
